import {
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';


@Component({
  selector: 'ngx-simple-message-modal',
  templateUrl: './simple-message-modal.component.html',
  styleUrls: ['./simple-message-modal.component.scss']
})
export class SimpleMessageModalComponent  {

  @Input() title = '';
  @Input() text = '';  // text should be sanitized

  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.closed.emit();
  }  

}
